"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.salesforceTheme = void 0;
const salesforce_1 = require("../../design/themes/salesforce");
const themeCopier_1 = require("../helpers/themeCopier");
const baseTheme_1 = require("./baseTheme");
const UIType_1 = require("../types/UIType");
exports.salesforceTheme = {
    uiType: UIType_1.UIType.classic,
    designTokens: new Map(baseTheme_1.baseTheme.designTokens)
};
(0, themeCopier_1.themeCopier)(salesforce_1.salesforceTheme, exports.salesforceTheme);
//# sourceMappingURL=salesforceTheme.js.map